var KeepaliveSvc = (function () {
    function KeepaliveSvc() {
    }
    return KeepaliveSvc;
}());
export { KeepaliveSvc };
//# sourceMappingURL=keepalivesvc.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@ng-idle/core/src/keepalivesvc.js
// module id = 280
// module chunks = 33